import React from "react";
import { CaseStatusSplitview } from "../../components/splitviews/case-status-splitview";

// Origin (CMSOR) is the origin system for cases that were pulled into RDN.
export type CaseStatusOrigin = "recoveryconnect";

export function CaseStatusPage(props) {
  return <CaseStatusSplitview {...props} />;
}
